export const SET_GEOMETRY_MAP_POINT ='SET_GEOMETRY_MAP_POINT';
export const SET_MAP_MANUAL_ADDRESS ='SET_MAP_MANUAL_ADDRESS';
export const SET_MAP_LAT_LONG ='SET_MAP_LAT_LONG';
export const SET_MAP_MANUAL_LAT_LONG ='SET_MAP_MANUAL_LAT_LONG';
export const SET_MAP_MANUAL_LAT_LONG_CLICKED ='SET_MAP_MANUAL_LAT_LONG_CLICKED';
export const SET_MAP_PINCODE_FIRST_TIME_EDIT ='SET_MAP_PINCODE_FIRST_TIME_EDIT';
export const SET_CREATE_MAP_PINCODE_WITH_HFR ='SET_CREATE_MAP_PINCODE_WITH_HFR';
export const SET_MAP_SERVICES_DOWN ='SET_MAP_SERVICES_DOWN';
export const SET_MAP_SERVICES_CREATE_POLYGON ='SET_MAP_SERVICES_CREATE_POLYGON';
export const SET_MAP_SERVICES_POLYGON_FOR_EDIT ='SET_MAP_SERVICES_POLYGON_FOR_EDIT';

export interface setGeometryMapPoint {
    type:typeof SET_GEOMETRY_MAP_POINT;
    payload: any
};

export interface setMapManualAddress {
    type:typeof SET_MAP_MANUAL_ADDRESS;
    payload: any
};

export interface setMapLatLong {
    type:typeof SET_MAP_LAT_LONG;
    payload: any
};

export interface setMapManualLatLong {
    type:typeof SET_MAP_MANUAL_LAT_LONG;
    payload: any
};

export interface setMapManualLatLongClicked {
    type:typeof SET_MAP_MANUAL_LAT_LONG_CLICKED;
    payload: any
};

export interface setMapPincodeFirstTimeEdit {
    type:typeof SET_MAP_PINCODE_FIRST_TIME_EDIT;
    payload: any
};

export interface setCreateMapPincodeWithHfr {
    type:typeof SET_CREATE_MAP_PINCODE_WITH_HFR;
    payload: any
};


export interface setMapServicesDown {
    type:typeof SET_MAP_SERVICES_DOWN;
    payload: any
};

export interface setMapServicesCreatePolygon {
    type:typeof SET_MAP_SERVICES_CREATE_POLYGON;
    payload: any
};

export interface setMapServicesPolygonForEdit {
    type:typeof SET_MAP_SERVICES_POLYGON_FOR_EDIT;
    payload: any
};

export type facilityGeoMapActionType = setGeometryMapPoint | setMapManualAddress | setMapLatLong | setMapManualLatLong | setMapManualLatLongClicked | setMapPincodeFirstTimeEdit | setCreateMapPincodeWithHfr | setMapServicesDown | setMapServicesCreatePolygon | setMapServicesPolygonForEdit;